import {
  CreditBalanceDto,
  PurchaseSubscriptionRequestDto,
} from './dto/request/purchase-subscription.request.dto';
import AppHttpClient from '../api-manager/api/http-client';
import HttpPathsEnum from '../api-manager/api/http-paths.enum';
import { HttpRequest, RequestType } from '../api-manager/api/http-request';
import { GetTotalMembershipResponseDto } from './dto/response/get-total-membership-response.dto';
import { PurchaseSubscriptionResponseDto } from './dto/response/purchase-subscription-response.dto';
import { GetTotalSubscriptionResponseDto } from './dto/response/get-total-subscription-response.dto';

const SUBSCRIPTION_PATH = HttpPathsEnum.SERVICES;

class SubscriptionManagementApi {
  public async getAllSubscriptions() {
    const request: HttpRequest = {
      url: `${SUBSCRIPTION_PATH}/subscription/filtered`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetTotalSubscriptionResponseDto>(
      request,
      GetTotalSubscriptionResponseDto
    );
  }

  public async getAllUserSubscriptions() {
    const request: HttpRequest = {
      url: `${SUBSCRIPTION_PATH}/membership`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetTotalMembershipResponseDto>(
      request,
      GetTotalMembershipResponseDto
    );
  }

  public async purchaseSubscription(
    create_membership_dto: PurchaseSubscriptionRequestDto,
    payment_dto: CreditBalanceDto
  ) {
    const request: HttpRequest = {
      url: `${SUBSCRIPTION_PATH}/membership`,
      method: RequestType.POST,
      data: {
        create_membership_dto,
        payment_dto,
      },
    };

    return await AppHttpClient.exec<any, PurchaseSubscriptionResponseDto>(
      request,
      PurchaseSubscriptionResponseDto
    );
  }

  public async cancelMembership(membership: number) {
    const request: HttpRequest = {
      url: `${SUBSCRIPTION_PATH}/membership/${membership}`,
      method: RequestType.DELETE,
    };

    return await AppHttpClient.exec<any, boolean>(request, Boolean);
  }
}

export default new SubscriptionManagementApi();
